import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import { initSentry } from './utils/sentry';

// Supervision des erreurs (inactif tant que REACT_APP_SENTRY_DSN n'est pas définie).
initSentry();

// L'API n'accepte plus les requêtes anonymes : chaque appel doit porter le
// cookie de session. On l'impose globalement pour tous les appels axios de
// l'appli (les appels fetch, eux, précisent credentials: 'include' au cas par cas).
axios.defaults.withCredentials = true;

// Session expirée / absente : l'API répond 401. Plutôt que de laisser
// l'utilisateur devant des pages vides (localStorage dit encore « connecté »
// alors que la session serveur est tombée), on le renvoie proprement vers la
// connexion. On ignore l'appel de login lui-même (401 = mauvais identifiants).
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const url = error.config?.url || '';
        if (status === 401 && !url.includes('/login')) {
            localStorage.removeItem('user');
            if (window.location.pathname !== '/login') {
                window.location.assign('/login');
            }
        }
        return Promise.reject(error);
    },
);

// Après un déploiement, les anciens fichiers JS/CSS n'existent plus sur le
// serveur : un navigateur qui a encore l'ancienne version en cache échoue à
// charger un chunk (ChunkLoadError, Sentry SPOT-FRONTEND-3). Un rechargement
// forcé récupère la nouvelle version. Garde-fou : un seul rechargement
// automatique, le drapeau est levé après 15 s de fonctionnement stable.
const estErreurChunk = (err) =>
    err?.name === 'ChunkLoadError'
    || /Loading (CSS )?chunk .+ failed/i.test(err?.message || '');
const rechargerSiChunkPerdu = (err) => {
    if (!estErreurChunk(err)) return;
    if (sessionStorage.getItem('chunk-reload') === '1') return;
    sessionStorage.setItem('chunk-reload', '1');
    window.location.reload();
};
window.addEventListener('error', (e) => rechargerSiChunkPerdu(e.error));
window.addEventListener('unhandledrejection', (e) => rechargerSiChunkPerdu(e.reason));
setTimeout(() => sessionStorage.removeItem('chunk-reload'), 15000);

// Écran de secours si React crashe (l'erreur est remontée à Sentry si actif) :
// mieux qu'une page blanche inexpliquée.
const CrashFallback = () => (
  <div className="crash-fallback">
    <h1>Oups, une erreur est survenue</h1>
    <p>L'équipe a été prévenue automatiquement. Essayez de recharger la page.</p>
    <button onClick={() => window.location.reload()}>Recharger la page</button>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
